import {Pipe, PipeTransform} from "@angular/core";
import {EbsWebService} from "../services/ebsWebService";

@Pipe({name: "loadImageFromStorage"})
export class LoadImageFromStorage implements PipeTransform {
  constructor(private _ebsWebService: EbsWebService) {
  }
  transform(value: string) {

      if (value == null) {
        return false;
      }
      let base64Image = this._ebsWebService.getIconFromStorage(value);
      return new Promise((resolve) => {resolve(base64Image)})

  }
}



// WEBPACK FOOTER //
// ./src/pipes/loadImageFromStorage.ts